import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageSelectorPublic } from "./LanguageSelectorPublic";

const HomePage: React.FC = () => {
    const { t } = useTranslation("common");

    return (
        <div className="min-h-screen bg-gray-900 flex flex-col justify-center items-center relative">
            {/* Селектор языка в правом верхнем углу */}
            <div className="absolute top-4 right-4">
                <LanguageSelectorPublic />
            </div>

            <div className="max-w-md w-full space-y-8">
                <div className="text-center">
                    <img
                        className="mx-auto h-24 w-auto"
                        src="/alny-logo.png"
                        alt="Alny Logo"
                    />
                    <h2 className="mt-6 text-3xl font-extrabold text-gray-200">
                        {t("welcome_title")}
                    </h2>
                    <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                        {t("welcome_subtitle")}
                    </p>
                </div>

                <div className="mt-8 space-y-4">
                    <Link
                        to="/signin"
                        className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        {t("auth.signin")}
                    </Link>

                    {/* <Link
                        to="/signup"
                        className="group relative w-full flex justify-center py-2 px-4 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-md text-gray-700 dark:text-gray-300 bg-white hover:bg-gray-50 dark:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        {t("auth.signup")}
                    </Link> */}
                </div>
            </div>
        </div>
    );
};

export default HomePage;
